export default __webpack_public_path__ + "static/media/client_logo1.e24f1251.png";